// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tab-common_tabs__32U5H"};